import { createApp } from 'vue'
import ContactPage from './ContactPage.vue'
import './assets/global.css'

createApp(ContactPage).mount('#contact')
